import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from '@mui/material';
import { BoxForm, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Translate, translate } from 'react-jhipster';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

export interface ILoginDialogProps {
  showModal: boolean;
  loginError: boolean;
  handleLogin: (username: string, password: string, rememberMe: boolean) => void;
  handleClose: () => void;
}

const LoginDialog = (props: ILoginDialogProps) => {
  const { loginError, handleClose } = props;
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: 'onTouched',
    defaultValues: {
      username: '',
      password: '',
      rememberMe: true,
    },
  });

  const onSubmit = data => {
    props.handleLogin(data.username, data.password, data.rememberMe);
  };

  useEffect(() => {
    if (loginError) {
      toast.error(translate('login.messages.error.authentication'), {
        position: 'top-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [loginError]);

  return (
    <Dialog
      open={props.showModal}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          backgroundColor: 'primary.main',
          backgroundImage: 'none',
          padding: 2,
        },
      }}
      sx={{
        boxShadow:
          'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
      }}
    >
      <BoxForm onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle id="login-title" data-cy="loginTitle">
          <Typography color="secondary" fontWeight={'700'} component="h1" variant="h5" align="center" sx={{ mb: 4, mt: 6 }}>
            <Translate contentKey="login.title">Sign in</Translate>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TypographyForms>
                <Translate contentKey="global.form.username.label">E-mail</Translate>
              </TypographyForms>
              <Controller
                name="username"
                control={control}
                rules={{ required: 'E-mail obrigatório' }}
                render={({ field }) => (
                  <TextFieldForms
                    {...field}
                    type="text"
                    required
                    autoFocus
                    fullWidth
                    data-cy="username"
                    error={!!errors.username}
                    helperText={errors.username?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TypographyForms>
                <Translate contentKey="login.form.password">Password</Translate>
              </TypographyForms>
              <Controller
                name="password"
                control={control}
                rules={{ required: 'Senha obrigatória' }}
                render={({ field }) => (
                  <TextFieldForms
                    {...field}
                    type={showPassword ? 'text' : 'password'}
                    required
                    fullWidth
                    data-cy="password"
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    InputProps={{
                      style: { borderRadius: '8px', marginRight: '8px' },
                      endAdornment: (
                        <InputAdornment position="end" style={{ marginRight: '5px' }}>
                          <IconButton edge="end" onClick={() => setShowPassword(!showPassword)} color="secondary">
                            {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="rememberMe"
                control={control}
                render={({ field }) => (
                  <FormControlLabel control={<Checkbox {...field} color="secondary" checked={field.value} />} label={translate('login.form.rememberme')} />
                )}
              />
            </Grid>
          </Grid>
          <Box component={Link} to="/account/reset/request" className="forget-password" data-cy="forgetYourPasswordSelector">
            <Typography component="span" mt={1} display="block" color={'#5989BE'} sx={{ mb: { xs: 4, md: 6 } }}>
              <Translate contentKey="login.password.forgot">Did you forget your password?</Translate>
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="contained" color="secondary" type="submit" data-cy="submit">
            <Translate contentKey="login.form.button">Sign in</Translate>
          </Button>
        </DialogActions>
      </BoxForm>
    </Dialog>
  );
};

export default LoginDialog;
